import script from "./RetractableScreenCoordinates.vue?vue&type=script&setup=true&lang=js"
export * from "./RetractableScreenCoordinates.vue?vue&type=script&setup=true&lang=js"

import "./RetractableScreenCoordinates.vue?vue&type=style&index=0&id=4bfd6624&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bfd6624"]])

export default __exports__